import React from 'react';
import { cn } from '../../utils/cn';

export type ClientPageIntroProps = {
  /** Shell page title — used as main headline when `heading` is omitted */
  pageTitle: string;
  /** Optional override for the large in-card headline */
  heading?: string;
  eyebrow?: string;
  description: React.ReactNode;
  className?: string;
};

/**
 * Client page hero intro — light welcome card, large title, guidance copy, then page body.
 */
export function ClientPageIntro({
  pageTitle,
  heading,
  eyebrow,
  description,
  className,
}: ClientPageIntroProps) {
  const headline = heading ?? pageTitle;

  return (
    <header className={cn('client-page-intro', className)}>
      <div className="client-page-intro__card app-welcome-card">
        <div className="client-page-intro__glow app-welcome-card-glow" aria-hidden />
        <div className="client-page-intro__inner">
          {eyebrow ? (
            <p className="client-hero-eyebrow client-page-intro__eyebrow">{eyebrow}</p>
          ) : null}
          <h1 className="client-hero-title app-heading-accent">{headline}</h1>
          <div className="client-hero-desc client-page-intro__desc">{description}</div>
        </div>
      </div>
    </header>
  );
}

export default ClientPageIntro;
